import { API_BASE_URL } from './apiConfig';

export const buildLogoUrl = (logo) => {
  if (!logo) return null;
  if (logo.startsWith('http')) return logo;
  if (logo.startsWith('blob:')) return logo;
  if (logo.startsWith('data:')) return logo;
  
  // For relative paths, prepend API_BASE_URL
  let path = logo;
  if (path.startsWith('/')) {
    path = path.slice(1); // Remove leading slash
  }
  if (path.startsWith('uploads')) {
    return `${API_BASE_URL}/${path}`;
  }
  return `${API_BASE_URL}/uploads/${path}`;
};

export const buildPhotoUrl = (photo) => {
  if (!photo) return null;
  if (photo.startsWith('http')) return photo;
  if (photo.startsWith('blob:')) return photo;
  if (photo.startsWith('data:')) return photo;
  
  // For relative paths, prepend API_BASE_URL
  let path = photo;
  if (path.startsWith('/')) {
    path = path.slice(1); // Remove leading slash
  }
  if (path.startsWith('uploads')) {
    return `${API_BASE_URL}/${path}`;
  }
  // Bare filename (e.g. playerPhoto_xxx.jpg): player photos are in uploads/players/
  if (!path.includes('/')) {
    return `${API_BASE_URL}/uploads/players/${path}`;
  }
  return `${API_BASE_URL}/uploads/${path}`;
};

export const buildBackgroundImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  if (imageUrl.startsWith('http')) return imageUrl;
  if (imageUrl.startsWith('blob:')) return imageUrl;
  if (imageUrl.startsWith('data:')) return imageUrl;
  
  // For relative paths, prepend API_BASE_URL
  let path = imageUrl;
  if (path.startsWith('/')) {
    path = path.slice(1); // Remove leading slash
  }
  if (path.startsWith('uploads')) {
    return `${API_BASE_URL}/${path}`;
  }
  return `${API_BASE_URL}/uploads/${path}`;
};

